<template>
  <div class="header-container">
    <div class="header-bar">
      <div class="header-bar-inner">
        <router-link :to="{name: 'shopnetHome'}" class="logo-container">
          <img :src="sellerLogoUrl" class="shop-logo">
        </router-link>

        <input
          v-if="!hideSearch"
          v-model="keyword"
          type="text"
          placeholder="Search products..."
          class="search-input"
          @keyup.enter="search()"
        >

        <div class="cart-info-container">
          <router-link id="open-cart" :to="{name: 'cartShow'}">
            <i class="fas fa-shopping-cart cart-icon" />
            <span class="cart-total-indicator">
              {{ cartTotal }}
            </span>
          </router-link>


          <transition name="drop-toast">
            <div v-if="showAddedItemsToast" class="added-cart-toast">
              {{ addedItemsCount }} item{{ pluralisedAddedItem }} added
            </div>
          </transition>
        </div>

        <div class="mobile-category-section" @click="openMobile">
          <i v-if="showCategoryTrigger" class="fas fa-bars" />
          <i v-if="!showCategoryTrigger" class="fas fa-arrow-circle-left" @click="$router.push({ name: 'shopnetHome' })" />
        </div>
      </div>
    </div>
    <div :class="{ 'buyer-id': true, 'hide-mobile': hideBuyerIdOnMobile }">
      <div v-if="buyerName && loggedIn" class="buyer-id">
        Shopping as {{ buyerName }}
      </div>
      <div v-if="!buyerName && !loggedIn" class="buyer-id">
        Shopping as a Guest. <a :href="`/login?redirect_after_login=%2Fshop`">Sign in</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    initCart: { type: String, required: false, default: undefined },
    initSearch: { type: String, required: false, default: undefined },
    loginPath: { type: String, required: true },
    sellerLogoUrl: { type: String, required: true },
    hideBuyerIdOnMobile: { type: Boolean, required: false, default: false },
    hideSearch: { type: Boolean, default: false, required: false },
    showCategoryTrigger: { type: Boolean, default: true, required: false},
    loggedIn: { type: Boolean, required: true },
  },
  data() {
    return {
      cart: this.initCart,
      cartProducts: [],
      showAddedItemsToast: false,
      addedItemsCount: 0,
      keyword: this.initSearch,
    };
  },
  computed: {
    cartTotal: function() {
      return this.$store.getters.cartTotal;
    },
    buyerName: function() {
      return this.$store.state.buyerDetails.buyer_name;
    },
    cartPrice: function() {
      return this.$store.state.cartPrice;
    },
    products: function() {
      return this.$store.state.products;
    },
    lastProductAdded: function() {
      return this.$store.state.lastProduct;
    },
    pluralisedAddedItem: function() {
      return (this.addedItemsCount > 1 ? "s" : "");
    },
  },
  watch: {
    products: function() {
      this.cartProducts = this.products;
    },
    initSearch: function() {
      this.keyword = this.initSearch;
    },
    lastProductAdded: function(val) {
      this.showAddedItemsToast = false;
      this.showAddedItemsToast = true;
      this.addedItemsCount = val.quantity;
      setTimeout(() => {
        this.showAddedItemsToast = false;
      }, 2000);
    },
  },
  methods: {
    search: function() {
      this.$emit('changeSearchTerm', this.keyword);
    },
    openMobile: function() {
      this.$emit('openCategoryMobile', this.keyword);
    },
  },
};
</script>
